// extracted by css-extract-rspack-plugin
export default {"cls1":"dossier-cls1_CdS","cls2":"dossier-cls2_AHd dossier-cls1_CdS"};